<div class="d-flex w-100 justify-content-center mt-5 mb-5">
  <h3>Ajouter une dose d'Intelligence Artificielle à votre application MonSuiviDiet</h3>
</div>
<div class="d-flex w-100 justify-content-center">
  <div class="feature-card-wrapper ml10px">
    <ng-container *ngIf="featureModel && !loadingSubscription; else innerFeatureLoading">
      <div class="feature-id-wrapper">
        <div class="price">
          <h2 class="price-label">{{ getPrice(featureModel.stripeProduct) }}</h2>
        </div>
        <div *ngIf="getPriceCrossedOut(featureModel.stripeProduct)" class="price-crossed-out">
          Offre découverte - Tarif habituel : <span>{{ getPriceCrossedOut(featureModel.stripeProduct) }}</span>
        </div>
        <div *ngIf="errorSubscription" class="feature-error">
          {{errorSubscription}}
        </div>
        <div *ngIf="featureModel.stripeProduct" class="feature-actions-wrapper">
          <button class="btn btn-gradient"
                  (click)="goSubscription()">
            <div>Démarrer</div>
          </button>
        </div>
      </div>
      <div class="feature-content-wrapper">
        <div *ngFor="let detail of featureModel.feature.details">
          <i-bs [name]="'check'" height="1.7rem" width="1.7rem"></i-bs>
          <span class="feature-cell-label" [innerHTML]="detail"></span>
        </div>
      </div>
      <div class="feature-discovery-wrapper">
        <button class="btn btn-outline"
                (click)="discoveryTour()">
          <div>Découvrir l'option en détail</div>
        </button>
      </div>
    </ng-container>
  </div>

  <div *ngFor="let model of bundledFeaturesModels" class="feature-card-wrapper ml10px">
    <ng-container *ngIf="model && !loadingSubscription; else innerFeatureLoading">
      <div class="bundle-image">
        <img src="assets/images/offre2.png" alt="offre">
      </div>
      <div class="bundle-title">
        <h3>
          <ng-container *ngFor="let t of model.bundle.label.split('+'); let last = last">
            <div>{{ t }}</div>
            <div *ngIf="!last">
              <i-bs name="plus-circle-dotted" height="35" width="35"></i-bs>
            </div>
          </ng-container>
        </h3>
      </div>
      <div class="feature-id-wrapper">
        <div class="price">
          <h2 class="price-label">{{ getPrice(model.stripeProduct) }}</h2>
        </div>
        <div *ngIf="errorSubscription" class="feature-error">
          {{errorSubscription}}
        </div>
        <div *ngIf="getPriceCrossedOut(model.stripeProduct)" class="price-crossed-out">
          Tarif habituel : <span>{{ getPriceCrossedOut(model.stripeProduct) }}</span>
        </div>
      </div>
      <div class="feature-content-wrapper">
        <div *ngFor="let detail of model.bundle.details">
          <i-bs [name]="'check'" height="1.7rem" width="1.7rem"></i-bs>
          <span class="feature-cell-label" [innerHTML]="detail"></span>
        </div>
      </div>
      <div class="feature-id-wrapper">
        <div *ngIf="model.stripeProduct" class="feature-actions-wrapper mt2px">
          <button class="btn btn-gradient"
                  (click)="goSubscription()">
            <div>Profitez de l'offre</div>
          </button>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-template #innerFeatureLoading>
    <ngx-inner-loading class="flex-center" [loading]="loadingSubscription"
                       [loadingDescription]="'Chargement...'"
                       [error]="!!errorSubscription"
                       [emptyDescription]="'Aucun abonnement disponible...'"
                       [errorDescription]="errorSubscription"
                       [retryButtonText]="'Réessayer'">
    </ngx-inner-loading>
  </ng-template>
</div>


